import { render } from "./AchievementNotification3.vue?vue&type=template&id=c93f4054"
import script from "./AchievementNotification3.vue?vue&type=script&lang=js"
export * from "./AchievementNotification3.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/achievementNotifications/AchievementNotification3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c93f4054"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c93f4054', __exports__)) {
    api.reload('c93f4054', __exports__)
  }
  
  module.hot.accept("./AchievementNotification3.vue?vue&type=template&id=c93f4054", () => {
    api.rerender('c93f4054', render)
  })

}


export default __exports__